import Vue from 'vue';
import QRious from "qrious";

export default {    

  printTicketVentaNotaCredito(credit_note, sale ){

    console.log(" credit_note ===>>> ", credit_note)
    console.log("voucher ----->>>>> ", sale)


     const serie = sale.sales_document
     let facturaOrBoleta = false;
     if(serie == "FACTURA"){
       facturaOrBoleta = true;
     }
 
     let itemsProducts = ``;
     let logo_ticket = "";
     const link = credit_note.credit_link_pdf ? credit_note.credit_link_pdf : "";
 
     const qr = new QRious({
       value: link, // La URL o el texto
       size: 500,
       backgroundAlpha: 0, // 0 para fondo transparente
       foreground: "#000000", // Color del QR
       level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
     });
 
     const [date, hour] = credit_note.credit_note_date.split(" ");
     const [year, month, day] = date.split("-");
     const newDate = [day, month, year].join("-");
 
     let style = `<style type="text/css" media="screen, print">
     @import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');
     @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
     
     .voucher-content{ 
         font-family: 'Open Sans', sans-serif;
         font-size: 07px;
         margin-left: 5px;
         margin-right: 5px;
         
     }
     .ticket {
       width: 160px;
       max-width: 160px;
     }
     .border-div{
       border-top: 0.1px solid #ECECEC;
     }
     .border-general{
       border: 0.1px solid #ECECEC;
       border-radius: 5px;
     }
     .voucher-label{
       line-height: 0.8
     }
     .td-operation{
       width: 10%; 
       text-align: center;
     }
   </style>`;
 
     // ! reporte - ventas pdf
     if (sale.company_img_url) {
       logo_ticket = `<img class="imgCenter" src='/img/${sale.company_img_url}' height="47" width="130" />`;
     }
 
     let company_phone = "";
     if (sale.company_phone) {
       company_phone = `<span>${sale.company_phone}</span><br>`;
     }
 
     let type_document = "NOTA DE CREDITO DE VENTA ELECTRÓNICA";
     if (sale.sales_document === "BOLETA") {
       type_document = "BOLETA NOTA DE CREDITO DE VENTA ELECTRÓNICA";
     } else if (sale.sales_document === "TICKET") {
       type_document = "TICKET NOTA DE CREDITO DE VENTA ELECTRÓNICA";
     }
 
     let customer_address = "";
     if (sale.customer_address) {
       customer_address = sale.customer_address.toUpperCase();
     }
 
     let paymentMethod = "";
     if (sale.payment_method) {
       paymentMethod = sale.payment_method;
     }
 
     let payWith = "";
     if (paymentMethod == "EFECTIVO") {
       if (sale.pay_with > 0) {
         payWith = `
               <tr>
                 <td style="width: 70%; text-align: right;">
                     <span class="voucher-label"><b>PAGA CON</b></span>
                 </td>
                 <td class="td-operation">
                   <span class="voucher-label"><b>S/</b></span>
                 </td>
                 <td style="width: 30%; text-align: right;">
                     <span class="voucher-label"><b> ${parseFloat(
                       sale.pay_with
                     ).toFixed(2)}</b></span>
                 </td>
               </tr>
               <tr>
                 <td style="width: 70%; text-align: right;">
                     <span class="voucher-label"><b>VUELTO</b></span>
                 </td>
                 <td class="td-operation">
                     <span class="voucher-label"><b>S/</b></span>
                 </td>
                 <td style="width: 30%; text-align: right;">
                     <span class="voucher-label"><b> ${parseFloat(
                       sale.change
                     ).toFixed(2)}</b></span>
                 </td>
               </tr>
             `;
       }
     }
     //<label> ${sale.company_address}</label>
     let reporteCabecera = `
     <div style="display:flex; width:100%;">
       <div style="width: 45%; display:flex; align-items: center;">
         <img class="imgCenter" src='/img/${sale.company_img_url}' height="17" width="100%" />
       </div>
       <div style="display:flex; flex-direction:column; font-size:4.5px; padding-top:5px; width: 55%; padding-left:3px; text-align:end; ">
         <label style="font-weight: 900;">TOMOLAB S.A.C</label>
         <label>CAL.COLOMBIA NRO. 109
         URB. EL RECREO ET. 1 LA
         LIBERTAD - TRUJILLO</label>
       </div>
     </div>
     <div style="font-size:5px; display:flex; width:100%; margin-top: 5px; flex-direction: column;">  
       <div style="display:flex; width:100%;">
         <div style="display:flex; width:25%;">
           <label style="font-weight: 900;"> Sucursal </label>
         </div>
         <div style="display:flex; width:75%">
           <label>: ${sale.office_address}</label>
         </div>
       </div>
       <div style="display:flex; width:100%; margin-top: 3px;">
         <div style="display:flex; width:25%;">
           <label style="font-weight: 900;"> Telefono(s) </label>
         </div>
         <div style="display:flex; width:75%">
           <label>: ${sale.office_phone}</label>
         </div>
       </div>
     </div>
 
     <div style="display:flex; margin-top: 7px; font-weight: 900;">
       <label style="">RUC :  ${sale.company_ruc}</label>
     </div>
 
     <div style="">
       <span><b>${type_document}</b></span><br>
       <span><b>${credit_note.credit_note_serie} - ${credit_note.credit_note_correlative}</b></span><br><br>
     </div>
 
     `;
 
     //let items = [];
     sale.detail.forEach((el) => {
       let quantity = el.quantity.toString().padStart(3, "0");
       let name = el.description.trim();
       let value_subtotal = parseFloat(el.subtotal);
       let value_discount = 0;
       if (el.discount_value) {
         value_discount = parseFloat(el.discount_value);
       }
       let subtotal_item =
         Math.round((value_subtotal - value_discount) * 100) / 100;
       let subtotal = ` ${parseFloat(subtotal_item).toFixed(2)}`.padStart(
         30,
         " "
       );
 

 
       itemsProducts += `
       <tr>
         <td style="text-align: left; vertical-align: top;" colspan="5">${name}</td>
       </tr>
       <tr style="">
         <td style="text-align: left; vertical-align: top;">${el.code}</td> 
         <td style="text-align: right; vertical-align: top;">${(parseFloat(el.price) /  1.18 ).toFixed(2) }</td> 
         <td style="text-align: right; vertical-align: top;">1</td> 
         <td style="text-align: right; vertical-align: top;">${subtotal}</td> 
         <td style="text-align: right; vertical-align: top;">UND</td> 
         <td style="text-align: right; vertical-align: top;">${(parseFloat(el.price) /  1.18 ).toFixed(2) }</td>           
       </tr>`;
     });
 

 
     let metodoPago = "CONTADO";
     if (sale.credit_sale == true && sale.payment_method == null) {
       metodoPago = "CREDITO";
     }
 
     let namecliente = "";
     if (sale.client_name != null) {
       namecliente = sale.client_name;
     }
 
     let content = "";
     let fechaVenc = sale.sales_date;
     if (sale.credit_sale == true || sale.credit_sale == "true") {
       fechaVenc = sale.payment_date;
     }
 
     let campoObservacion = `
     <div style="padding: 5px 0px;">
       <b><label >Observacion</label></b>
       <div style="display:flex; width: 100%; height: 30px; background-color:white; margin-top:3px;" class="border-general">
         <label style="margin-left:2px; margin-top:2px;">
           ${sale.sale_observation}
         </label>
       </div>
     </div>
     `
 
     let metodo_de_pago_footer = `
 
       ${facturaOrBoleta == true  ? campoObservacion : "" }
       <span><b>METODO DE PAGO: </b>${paymentMethod}</span><br>
       <span><b>FORMA DE PAGO: </b>${metodoPago}</span><br>
       <span><b>MOTIVO DE EMISIÓN: </b>${credit_note.credit_note_reason}</span><br>
       <span><b>DOCUMENTO RELACIONADO: </b>${sale.sales_document + " " + credit_note.sale_serie + " - "+ credit_note.sale_correlative}</span><br>
     `

 
     if(parseFloat(sale.total_gratuitas)>0){
       metodo_de_pago_footer = `
       <div style="display:flex; justify-content:center; flex-direction:column;">
         <label style="display:flex; text-align: center;"><b>TRANSFERENCIA GRATUITA DE UN BIEN O SERVICIO PRESTADO GRATUITAMENTE</b></label>
         <label style="display:flex; text-align: center;">  Representación impresa de la BOLETA DE VENTA ELECTRÓNICA, para ver el documento visita </label>
         <label style="display:flex; justify-content:center; font-weight: 700;"> https://wostsolutions.pse.pe/20606387670</label>
 
       </div>
       `;
     }
 
     let info_cliente = "";
 
     if (
       (sale.is_client == false || sale.is_client == "false") &&
       (sale.empresa_name != null || sale.empresa_name != "")
     ) {
       info_cliente = `
         
         <div style="font-size:6px; display:flex; width:100%; flex-direction: column;">  
           <div style="display:flex; width:100%;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> Cliente </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${
                 sale.company_name ? sale.company_name.toUpperCase() : ""
               }</label>
             </div>
           </div>
           <div style="display:flex; width:100%; margin-top: 3px;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> RUC </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${sale.company_ruc}</label>
             </div>
           </div>
           <div style="display:flex; width:100%; margin-top: 3px;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> DIRECCION </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${
                 sale.company_address ? sale.company_address : ""
               }</label>
             </div>
           </div>
         </div>
         `;
     } else if (sale.client_document != null && sale.client_name != null) {
       info_cliente = `
         
         <div style="font-size:6px; display:flex; width:100%;  flex-direction: column;">  
           <div style="display:flex; width:100%;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> Cliente </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${namecliente.toUpperCase()}</label>
             </div>
           </div>
           <div style="display:flex; width:100%; margin-top: 3px;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> RUC </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${sale.client_document}</label>
             </div>
           </div>
           <div style="display:flex; width:100%; margin-top: 3px;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> DIRECCION </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${sale.client_address}</label>
             </div>
           </div>
         </div>
         `;
     } else {
       info_cliente = `
         
         <div style="font-size:6px; display:flex; width:100%;  flex-direction: column;">  
           <div style="display:flex; width:100%;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> Cliente </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${
                 sale.customer_name ? sale.customer_name.toUpperCase() : ""
               }</label>
             </div>
           </div>
           <div style="display:flex; width:100%; margin-top: 3px;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> ${
                 sale.customer_type_document
               } </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${sale.customer_document}</label>
             </div>
           </div>
           <div style="display:flex; width:100%; margin-top: 3px;">
             <div style="display:flex; width:25%;">
               <label style="font-weight: 900;"> DIRECCION </label>
             </div>
             <div style="display:flex; width:75%">
               <label>: ${customer_address}</label>
             </div>
           </div>
         </div>
 
         `;
     }
 
     let info_calcular = `<div>
         <span><b>FECHA EMISION: </b>${Vue.prototype
           .$moment(sale.sales_date)
           .format("DD/MM/YYYY")}</span><br>
         <span><b>FECHA VENC: </b>${Vue.prototype
           .$moment(fechaVenc)
           .format("DD/MM/YYYY")}</span><br>             
         <span><b>VENDEDOR: </b>${sale.seller_full_name.toUpperCase()}</span><br>
         <span><b>MONEDA:</b> SOLES</span><br>
         <span><b>TIPO DE CAMBIO</b></span><br>
         <span><b>IGV:</b> 18.00%</span>
         <br>
     </div>`;
 
     content = `      
     ${style}
     <div class="voucher-content ticket">
     ${reporteCabecera}
 
     ${info_cliente}
 
     <div style="width:100%; font-size:6px; margin-top:3px; margin-bottom:3px;">
       
       <div style="width:100%; display:flex; margin-bottom:1px;">
         <div style="width:45%; display:flex;">
           <div style="width: 40%;">
             <b>Moneda</b>
           </div>
           <div style="width: 60%;">
             <label> : SOL </label>
           </div>
         </div>
         <div style="width:55%; display:flex;">
           <div style="width: 50%;">
           <b>Fecha</b>
           </div>
           <div style="width: 50%;">
           : ${newDate}
           </div>
         </div>
       </div>
 
       <div style="width:100%;  display:flex;">
         <div style="width:45%; display:flex;">
           <div style="width: 40%;">
           <b>Hora</b>
           </div>
           <div style="width: 60%;">
             <label> : ${hour} </label>
           </div>
         </div>
 
         <div style="width:55%; display:flex;">
           <div style="width: 50%;">
           <b>Atendido por</b>
           </div>
           <div style="width: 50%;">
           : ${sale.seller_first_name ? sale.seller_first_name[0] : " "}
           ${sale.seller_last_name ? sale.seller_last_name : ""}
           </div>
         </div>
       </div>
 
     </div>
 
         
             <table style="width: 100%; border-top: 0.1px solid #ECECEC; border-bottom: 0.1px solid #ECECEC;font-size: 5px; border-collapse: collapse;">
                 <thead>
                     <tr>
                         <th style="text-align: left; width: 15%;">C. Sunat</th>
                         <th style="text-align: right; width: 25%;">Valor unitario</th>
                         <th style="text-align: right; width: 10%;">Cant.</th>
                         <th style="text-align: right; width: 20%;">P. Unitario</th>
                         <th style="text-align: right; width: 10%;">UM</th>
                         <th style="text-align: right; width: 20%;">Valor Total</th>
                     </tr>
                 </thead>
                 <tbody>
                     ${itemsProducts}
                 </tbody>
             </table>
         <div>
             <table style="width: 100%;font-size: 5px; border-bottom: 1px solid #ECECEC;">
                 <tbody>
                     <tr>
                         <td style="width: 70%; text-align: right;">
                             <span class="voucher-label"><b>OP. GRATUITAS</b></span>
                         </td>
                         <td class="td-operation">
                             <span class="voucher-label"><b>S/</b></span>
                         </td>
                         <td style="width: 30%; text-align: right;">
                             <span class="voucher-label"><b> ${parseFloat(
                               sale.total_gratuitas
                             ).toFixed(2)}</b></span>
                         </td>
                     </tr>
                     <tr>
                         <td style="width: 70%; text-align: right;">
                             <span class="voucher-label"><b>DESCUENTO (-)</b></span>
                         </td>
                         <td class="td-operation">
                             <span class="voucher-label"><b>S/</b></span>
                         </td>
                         <td style="width: 30%; text-align: right;">
                             <span class="voucher-label"><b> ${parseFloat(
                               sale.discount
                             ).toFixed(2)}</b></span>
                         </td>
                     </tr>
                     <tr>
                         <td style="width: 70%; text-align: right;">
                             <span class="voucher-label"><b>GRAVADAS</b></span>
                         </td>
                         <td class="td-operation">
                             <span class="voucher-label"><b>S/</b></span>
                         </td>
                         <td style="width: 30%; text-align: right;">
                             <span class="voucher-label"><b> ${parseFloat(
                               sale.subtotal
                             ).toFixed(2)}</b></span>
                         </td>
                     </tr>
                     
                     
                     <tr>
                         <td style="width: 70%; text-align: right;">
                             <span class="voucher-label"><b>IGV</b></span>
                         </td>
                         <td class="td-operation">
                             <span class="voucher-label"><b>S/</b></span>
                         </td>
                         <td style="width: 30%; text-align: right;">
                             <span class="voucher-label"><b> ${parseFloat(
                               sale.igv
                             ).toFixed(2)}</b></span>
                         </td>
                     </tr>
                     <tr>
                       <td style="width: 70%; text-align: right;">
                           <span class="voucher-label"><b>REDONDEO</b></span>
                       </td>
                       <td class="td-operation">
                             <span class="voucher-label"><b>S/</b></span>
                         </td>
                       <td style="width: 30%; text-align: right;">
                           <span class="voucher-label"><b> ${parseFloat(
                             sale.rounding
                           ).toFixed(2)}</b></span>
                       </td>
                     </tr>
                     <tr>
                         <td style="width: 70%; text-align: right;">
                             <span class="voucher-label"><b>TOTAL</b></span>
                         </td>
                         <td class="td-operation">
                             <span class="voucher-label"><b>S/</b></span>
                         </td>
                         <td style="width: 20%; text-align: right;">
                             <span class="voucher-label"><b> ${parseFloat(
                               sale.total_rounded
                             ).toFixed(2)}</b></span>
                         </td>
                     </tr>
                     ${payWith}
                     <tr>
                         <td colspan="2">
                             <br>
                             <span><i><b>SON: ${this.NumerosaLetras(
                               parseFloat(sale.total_rounded).toFixed(2)
                             ).toUpperCase()} SOLES</b></i></span>
                         </td>
                     </tr>
                     
                 </tbody>
             </table>
         </div>
         <div style="font-size:6px;">
           ${metodo_de_pago_footer}
           
           <div style="display:flex; justify-content:center; width:100%; margin:5px 0; flex-direction: column; align-items: center;">
             <div style="display:flex; width:35px; height:35px;">
               <img src="${
                 qr.image.src
               }" style="width: 100%; height: 100%;"></img>
             </div>
             <label style="margin-top:3px; font-size:5px; display:flex; justify-content:center;">Representación Impresa de la ${type_document}</label>
           </div>
           <div class="border-div"></div>
           
             
         </div>
         <br>
         <br>
         <br>
     </div>`;
 
     
     return content;

  },
    
  
  
  printTicket(creditNote, sale) {

       let itemsProducts = ``;
       let logo_ticket = '';
       
       if (sale.company_img_url) {
        logo_ticket = `<img class="imgCenter" src='/img/${sale.company_img_url}' height="60" width="280" />`;
       }

       let company_phone = '';
       if (sale.company_phone) {
        company_phone = `<span>${sale.company_phone}</span><br>`;
       }

       let type_document = 'NOTA DE CRÉDITO ELECTRÓNICA';
       let type_document_ref = 'Factura Electrónica';
        if (sale.sales_document === 'BOLETA') {
            type_document_ref = 'Boleta de Venta Electrónica';
        }

        let customer_address = '';
        if (sale.customer_address) {
          customer_address = sale.customer_address.toUpperCase();
        }

        let discount_amount = '';
        if (parseFloat(sale.discount) > 0) {
            discount_amount = `<span class="voucher-label"><b>S/ ${parseFloat(sale.discount).toFixed(2)}-</b></span>`;
        } else {
            discount_amount = `<span class="voucher-label"><b>S/ ${parseFloat(sale.discount).toFixed(2)}</b></span>`;
        }

        //let items = [];
        sale.detail.forEach(el => {
            let quantity = el.quantity.toString().padStart(3, '0')
            let name = el.description.trim();
            let value_subtotal = parseFloat(el.subtotal);
            let value_discount = 0;
            if (el.discount_value) {
              value_discount = parseFloat(el.discount_value);
            }            
            let subtotal_item = Math.round((value_subtotal - value_discount) * 100) / 100;
            let subtotal = `S/. ${parseFloat(subtotal_item).toFixed(2)}`.padStart(30, ' ');
            
            itemsProducts += `<tr>
                <td style="text-align: left; vertical-align: top;"><b>${quantity}</b></td>
                <td style="text-align: left; vertical-align: top;">${name}</td>
                <td style="text-align: right; vertical-align: top;">${parseFloat(el.price).toFixed(2)}</td>
                <td style="text-align: right; vertical-align: top;">${subtotal}-</td>
            </tr>`;
        });

        let content = `        
          <style type="text/css" media="screen, print">
            @import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');
        
            @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
            
            .voucher-content{ 
                font-family: 'Open Sans', sans-serif;
                font-size: 10px;
                margin-left: 0px;
                margin-right: 0px;
            }
          </style>
        
        <div class="voucher-content">
        <div style="text-align: center">
             ${logo_ticket}
             <br>
            <br>
            <span><b>${sale.company_name}</b></span><br>
            <span><b>${sale.company_ruc}</b></span><br>
            <span>${sale.company_address}</span><br>
            ${company_phone}
            <br>
            <span><b>${type_document}</b></span><br>
            <span><b>${creditNote.credit_note_serie} - ${creditNote.credit_note_correlative}</b></span><br><br>
        </div>
        <div>
            <span><b>ADQUIRIENTE</b></span><br>
            <span><b>${sale.customer_type_document}: </b>${sale.customer_document}</span><br>
            <span>${sale.customer_name ? sale.customer_name.toUpperCase() : ""}</span><br>
            <span><b>DIRECCIÓN</b></span><br>
            <span>${customer_address}</span><br>
            <span><b>FECHA EMISION: </b>${Vue.prototype.$moment(creditNote.credit_note_date).format('DD/MM/YYYY')}</span><br>        
            <span><b>MONEDA: </b>SOLES</span><br>
            <span><b>IGV: </b>18.00</span><br>
            <span><b>VENDEDOR: </b>${sale.seller_name ? sale.seller_name.toUpperCase() : ""}</span>
        </div>
        <div>
            <table style="width: 100%; border-top: 2px solid; border-bottom: 2px solid;font-size: 10px; border-collapse: collapse;">
                <thead>
                    <tr>
                        <th style="text-align: left; width: 10%;">CANT</th>
                        <th style="text-align: left; width: 40%;">DESCRIPCION</th>
                        <th style="text-align: right; width: 25%;">P/U</th>
                        <th style="text-align: right; width: 25%;">TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    ${itemsProducts}
                </tbody>
            </table>
        </div>
        <div>
            <table style="width: 100%;font-size: 10px;border-bottom: 2px solid;">
                <tbody>
                    <tr>
                        <td style="width: 70%; text-align: left;">
                            <span class="voucher-label"><b>OP. GRAVADAS</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b>S/ ${parseFloat(sale.subtotal).toFixed(2)}-</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: left;">
                            <span class="voucher-label"><b>OP. GRATUITAS</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b>S/ ${parseFloat(sale.total_gratuitas).toFixed(2)}</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: left;">
                            <span class="voucher-label"><b>TOT. DESCUENTO GLOBAL</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            ${discount_amount}
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: left;">
                            <span class="voucher-label"><b>I.S.C</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b>S/ 0.00</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: left;">
                            <span class="voucher-label"><b>I.G.V (18%)</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b>S/ ${parseFloat(sale.igv).toFixed(2)}-</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: left;">
                            <span class="voucher-label"><b>OTROS TRIBUTOS</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b>S/ 0.00</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: left;">
                            <span class="voucher-label"><b>REDONDEO</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b>S/ ${parseFloat(sale.rounding).toFixed(2)}</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: left;">
                            <span class="voucher-label"><b>TOTAL VENTA</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b>S/ ${parseFloat(sale.total_rounded).toFixed(2)}-</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <br><br>
                            <span><i>SON: ${this.NumerosaLetras(parseFloat(sale.total_rounded).toFixed(2)).toUpperCase()} SOLES</i></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div style="width: 100%;font-size: 10px;text-align: center">
            <table style="font-size: 10px;">
                <tbody>
                    <tr>
                        <td>
                            <span>Representación impresa del documento electrónico, esta puede ser consultado en:</span>
                            <br>
                            https://sendatisolutions.com/
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: center;">
                            <div id="qrcode">
                                <img src="/img/qr-senda.png" width="110px" height="110px" />
                                <br/>
                                <br/>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div style="width: 100%;font-size: 10px;text-align: center">
            <table style="width: 100%;font-size: 10px;border-top: 2px solid;">
                <tbody>
                    <tr>
                        <td colspan="2">Anulación de la operación</td>
                    </tr>
                    <tr>
                        <td>Tipo documento referencia</td>
                        <td>${type_document_ref}</td>
                    </tr>
                    <tr>
                        <td>No. documento referencia:</td>
                        <td>${sale.serie}-${sale.correlative}</td>
                    </tr>
                    <tr>
                        <td>Fecha documento referencia</td>
                        <td>${Vue.prototype.$moment(sale.sales_date).format('DD/MM/YYYY')}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <br>
        <br>
        </div>`;

        return content
    },

    NumerosaLetras (cantidad) {
        var numero = 0;
        cantidad = parseFloat(cantidad);
      
        if (cantidad == "0.00" || cantidad == "0") {
          return "CERO con 00/100 ";
        } else {
          var ent = cantidad.toString().split(".");
          var arreglo = this.separar_split(ent[0]);
          var longitud = arreglo.length;
      
          switch (longitud) {
            case 1:
              numero = this.unidades(arreglo[0]);
              break;
            case 2:
              numero = this.decenas(arreglo[0], arreglo[1]);
              break;
            case 3:
              numero = this.centenas(arreglo[0], arreglo[1], arreglo[2]);
              break;
            case 4:
              numero = this.unidadesdemillar(arreglo[0], arreglo[1], arreglo[2], arreglo[3]);
              break;
            case 5:
              numero = this.decenasdemillar(arreglo[0], arreglo[1], arreglo[2], arreglo[3], arreglo[4]);
              break;
            case 6:
              numero = this.centenasdemillar(arreglo[0], arreglo[1], arreglo[2], arreglo[3], arreglo[4], arreglo[5]);
              break;
          }
      
          ent[1] = isNaN(ent[1]) ? '00' : ent[1];

          if (ent[1].length == 1) {
            ent[1] = ent[1] + '0';
          }
          
          return numero.trim() + " con " + ent[1] + "/100";
        }
      },
      
      unidades(unidad) {
        let unidades = Array('UN ','DOS ','TRES ' ,'CUATRO ','CINCO ','SEIS ','SIETE ','OCHO ','NUEVE ');
      
        return unidades[unidad - 1];
      },
      
      decenas(decena, unidad) {
        let diez = Array('ONCE ','DOCE ','TRECE ','CATORCE ','QUINCE' ,'DIECISEIS ','DIECISIETE ','DIECIOCHO ','DIECINUEVE ');
        let decenas = Array('DIEZ ','VEINTE ','TREINTA ','CUARENTA ','CINCUENTA ','SESENTA ','SETENTA ','OCHENTA ','NOVENTA ');
      
        if (decena ==0 && unidad == 0) {
          return "";
        }
      
        if (decena == 0 && unidad > 0) {
          return this.unidades(unidad);
        }
      
        if (decena == 1) {
          if (unidad == 0) {
            return decenas[decena -1];
          } else {
            return diez[unidad -1];
          }
        } else if (decena == 2) {
          if (unidad == 0) {
            return decenas[decena -1];
          }
          else if (unidad == 1) {
            let veinte = '';
            return veinte = "VEINTI" + "UNO";
          }
          else {
            let veinte = '';
            return veinte = "VEINTI" + this.unidades(unidad);
          }
        } else {
      
          if (unidad == 0) {
            return decenas[decena -1] + " ";
          }
          if (unidad == 1) {
            return decenas[decena -1] + " Y " + "UNO";
          }
      
          return decenas[decena -1] + " Y " + this.unidades(unidad);
        }
      },
      
      centenas(centena, decena, unidad) {
        let centenas = Array( "CIENTO ", "DOSCIENTOS ", "TRESCIENTOS ", "CUATROCIENTOS ","QUINIENTOS ","SEISCIENTOS ","SETECIENTOS ", "OCHOCIENTOS ","NOVECIENTOS ");
      
        if (centena == 0 && decena == 0 && unidad == 0) {
          return "";
        }
        if (centena == 1 && decena == 0 && unidad == 0) {
          return "CIEN ";
        }
      
        if (centena == 0 && decena == 0 && unidad > 0) {
          return this.unidades(unidad);
        }
      
        if (decena == 0 && unidad == 0) {
          return centenas[centena - 1]  +  "" ;
        }
      
        if (decena == 0) {
          var numero = centenas[centena - 1] + "" + this.decenas(decena, unidad);
          return numero.replace(" Y ", " ");
        }
        if (centena == 0) {
      
          return  this.decenas(decena, unidad);
        }
      
        return centenas[centena - 1]  +  "" + this.decenas(decena, unidad);
      
      },
      
      unidadesdemillar(unimill, centena, decena, unidad) {
        let numero = this.unidades(unimill) + " MIL " + this.centenas(centena, decena, unidad);
        numero = numero.replace("UN  MIL ", "MIL " );
        if (unidad == 0) {
          return numero.replace(" Y ", " ");
        } else {
          return numero;
        }
      },
      
      decenasdemillar(decemill, unimill, centena, decena, unidad) {
        let numero = this.decenas(decemill, unimill) + " MIL " + this.centenas(centena, decena, unidad);
        return numero;
      },
      
      centenasdemillar(centenamill,decemill, unimill, centena, decena, unidad) {
      
        let numero = 0;
        numero = this.centenas(centenamill,decemill, unimill) + " MIL " + this.centenas(centena, decena, unidad);
      
        return numero;
      },
      
      separar_split(texto){
        let contenido = new Array();
        for (var i = 0; i < texto.length; i++) {
          contenido[i] = texto.substr(i,1);
        }
        return contenido;
      }
}